import { useRootStore } from './useRootStore';

export function useActivityFeedStore() {
  const { activityFeedStore } = useRootStore();
  return activityFeedStore;
}
